import React, { ReactElement } from 'react';
import { Text, PlayerComponent } from '@shootsta/common-react';
import CtaButtons from '../../CtaButtons';
import { ICreateAnalyticsEntryQuery } from '../../../interfaces';
import { useShareablePageContext } from '../../../contexts/ShareablePageContext';
import { usePublicAssetContext } from '../../../contexts/PublicAssetContext';

import '../styles/_intro.scss';

interface IntroProps {
  assetId: string;
  createAnalyticsEntry: ICreateAnalyticsEntryQuery;
}

function Intro({
  createAnalyticsEntry,
  assetId
}: IntroProps): ReactElement {
  const { shareablePage } = useShareablePageContext();
  const { asset } = usePublicAssetContext();

  const {
    testimonials,
    shareablePageId,
    title,
    description
  } = shareablePage!;

  const hasTestimonials = !!testimonials?.length;

  return (
    <section className="intro">
      <Text centered heading1 className="intro__heading">
        {title}
      </Text>
      <Text centered subtitle className="intro__description">
        {description}
      </Text>
      <div className="intro__player">
        <PlayerComponent
          asset={asset}
          assetId={assetId}
          subscribeToAssetTranscoded={() => void 0}
          analyticsResourceId={shareablePageId}
          createAnalyticsEntry={createAnalyticsEntry}
          hideDownloadButton
          hideCaptionButton
        />
      </div>
      <div className="intro__actions">
        <CtaButtons shareablePageId={shareablePageId} />
      </div>
      {hasTestimonials && (
        <Text centered noMargin className="intro__tip">
          Or scroll down for some
          <b>&nbsp;great examples of content&nbsp;</b>
          and
          <b>&nbsp;client testimonials.</b>
        </Text>
      )}
    </section>
  );
}

export default Intro;
